//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum YearMode {
	Inherited = 0,
	CommercialYear = 1,
	SolarYear = 2
}
